
// need to send a string
export enum PROGRAM_MESSAGE_TYPE {
  USER = 'USER',
  API_FILE = 'API_FILE'
}
